import Utils from "../utils/utilities"

const uuid = require('uuid/v4')

export const singletonCache$: any = { }

function getUUID(target) {
    if (target.constructor.hashKey != undefined) {
        return target.constructor.hashKey
    }

    const ID: string = uuid()
    target.constructor.hashKey = ID
    return ID
}

export function getSingletonInstance(target: any): any {
    const uuid: string = getUUID(target)
    const typeFromCache: any = singletonCache$[uuid]

    if (Utils.isDefined(typeFromCache)) {
        return typeFromCache
    }

    singletonCache$[uuid] = target

    return target
}